module.exports = __webpack_public_path__ + "static/media/21.0638df8c.png";